export const PROPERTY_MARKETPLACE_STATES = {
  pending: { label: "Pending support review", color: "orange" },
  live: { label: "Live", color: "green" },
  withdrawn: { label: "Withdrawn from marketplace", color: "default" },
};

export function propertyMarketplaceStatus(application) {
  const value =
    application?.marketplace_status ||
    application?.loan_data?.marketplace?.status;
  return Object.hasOwn(PROPERTY_MARKETPLACE_STATES, value) ? value : "pending";
}

export const propertyMarketplaceLabel = (application) =>
  PROPERTY_MARKETPLACE_STATES[propertyMarketplaceStatus(application)].label;
